
import { NgModule } from '@angular/core';
import { InnerMenuComponent } from './inner-menu.component';
import { InnerMenuContentComponent } from './components/inner-menu-content/inner-menu-content.component';
import { InnerMenuSidebarComponent } from './components/inner-menu-sidebar/inner-menu-sidebar.component';
import { InnerMenuRoutingModule } from './inner-menu.routing.module';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/modules/shared.module';
import { InnerMenuSalesModule } from '../inner-menu-sales/inner-menu-sales.module';
import { InnerMenuLiveProcessModule } from '../inner-menu-liveprocess/inner-menu-liveprocess.module';
import { InnerMenuOldProcessModule } from '../inner-menu-oldprocess/inner-menu-oldprocess.module';
import { InnerMenuAccountModule } from '../inner-menu-account/inner-menu-account.module';
import { InnerMenuService } from './inner-menu.service';


import { IndividualSalesService } from '../inner-menu-sales/inner-menu-sales.service';


@NgModule({
    imports: [     
        CommonModule,
        SharedModule,
        InnerMenuRoutingModule,
        InnerMenuSalesModule,
        InnerMenuLiveProcessModule,
        InnerMenuOldProcessModule,
        InnerMenuAccountModule
    ],
    declarations: [
        InnerMenuComponent,
        InnerMenuContentComponent,
        InnerMenuSidebarComponent    
    ],
    providers: [
      InnerMenuService,
      IndividualSalesService
    ]
})
export class InnerMenuModule { }
